import React from "react";
import { PiSealWarningFill } from "react-icons/pi";
import { useUser } from "../../../context/user-context";
import { logo, smallLogo } from "../../../assets/images";

const Kyc3Start = ({ setOpenKyc, setOpenKyc3, setOpenKyc3Start }: any) => {
  const { theme } = useUser();
  return (
    <div className="fixed inset-0  flex font-manrope justify-start items-start pt-16 overflow-auto pb-16 bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-95  backdrop-blur-sm">
      <div
        className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
      >
        <div className="mt-6 w-full">
          {theme === "dark" ? (
            <img src={logo} className="mx-auto " alt="" />
          ) : (
            <img src={smallLogo} className="mx-auto " alt="" />
          )}
        </div>
        <div className="mt-10 w-full">
          <div className=" mx-auto bg-[#E8F3FC] rounded-lg p-3 w-1/3 flex justify-center items-center text-secondary_button font-bold text-[12px]">
            KYC Level Three
          </div>
          <div className="w-full mt-10">
            <h4 className="font-sora text-black dark:text-white text-[16px] text-left font-semibold">
              Please, read this information before starting the verification
              process
            </h4>
            <h4 className="font-sora text-gray-900 dark:text-gray-100 text-[11px] text-left mt-3 font-medium">
              You will need to:
            </h4>
            <h4 className="font-sora text-gray-900 dark:text-gray-100 text-[13px] text-left mt-1 font-medium">
              1. Provide a government issued ID
            </h4>
            <h4 className="font-sora text-gray-900 dark:text-gray-100 text-[13px] text-left mt-1 font-medium">
              2. Upload proof of address
            </h4>
            <h4 className="font-sora text-gray-900 dark:text-gray-100 text-[13px] text-left mt-1 font-medium">
              3. Take a selfie
            </h4>
            <div className="flex z-50 justify-center bg-[#FCF3E8] w-full p-3 items-start rounded-xl mt-4 gap-3 border-2 border-[#F28A0F]">
              <div>
                <PiSealWarningFill className="text-[20px] text-[#F28A0F]" />
              </div>

              <div className="w-full">
                <h4 className="font-sora text-gray-900 text-[11px] text-left mt-1 font-medium">
                  1. All documents must be original with no alterations
                </h4>
                <h4 className="font-sora text-gray-900  text-[11px] text-left mt-1 font-medium">
                  2. Use a clear picture with no exposure
                </h4>
                <h4 className="font-sora text-gray-900  text-[11px] text-left mt-1 font-medium">
                  3. Respect the corners of the document
                </h4>
                <h4 className="font-sora text-gray-900 text-[11px] text-left mt-1 font-medium">
                  4. please, use a background with adequate brightness for
                  better visibility
                </h4>
              </div>
            </div>
          </div>
          <div className="flex flex-col w-full mt-6">
            <button
              onClick={() => {
                setOpenKyc3(false);
                setOpenKyc(true);
              }}
              className="w-full bg-[#D4EBFD] rounded-lg text-secondary_button text-[16px] font-medium h-[48px]"
            >
              Cancel
            </button>
            <button
              onClick={() => {
                setOpenKyc3(false);
                setOpenKyc3Start(true);
              }}
              className="w-full  rounded-lg bg-secondary_button text-white mt-4 text-[16px] font-medium h-[48px]"
            >
              Verify my identity
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Kyc3Start;
